import { BadgeCheck, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const CandidateCard = ({
  name,
  image = "/image/default-avatar.png",
  party,
  partyLogo = "party.png",
  position,
  state,
  constituency,
  issuesResolved = 0,
  issuesRaised = 10,
  profileLink = "#",
  isVerified = false,
  isClaimed = false,
  isSameArea = false,
}) => {
  const resolutionRate =
    issuesRaised > 0
      ? Math.min(100, Math.round((issuesResolved / issuesRaised) * 100))
      : 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow hover:shadow-xl hover:border-green-500 transition overflow-hidden">
      {/* Header Image */}
      <div className="relative w-full h-44 overflow-hidden">
        <img
          src={image}
          onError={(e) => {
            e.target.src = "/image/default-avatar.png";
          }}
          alt={name}
          className="w-full h-full object-cover"
        />
        <div
          className={`absolute top-2 left-2 px-2 py-1 text-xs font-semibold rounded shadow 
          ${isClaimed ? "bg-green-600 text-white" : "bg-yellow-300 text-black"}`}
        >
          {isClaimed ? "Claimed" : "Unclaimed"}
        </div>

        {isSameArea && (
          <div className="absolute top-2 right-2 bg-orange-100 text-orange-800 text-xs font-semibold px-2 py-1 rounded shadow-sm flex items-center gap-1">
            <MapPin size={12} /> Your Area
          </div>
        )}
      </div>

      {/* Main Info */}
      <div className="p-4 space-y-2">
        <div className="flex items-center gap-3">
          <img
            src={`/party-logos/${partyLogo}`}
            onError={(e) => {
              e.target.src = "/party-logos/party.png";
            }}
            alt={party}
            className="w-8 h-8 rounded-full border object-cover"
          />
          <h3 className="text-lg font-bold text-gray-800">{name}</h3>
        </div>

        <p className="text-sm text-gray-600">
          {position} — {party}
        </p>
        <p className="text-sm text-gray-500">
          {constituency}, {state}
        </p>

        {/* Performance Bar */}
        <div className="mt-2">
          <div className="flex justify-between text-xs text-gray-500 mb-1">
            <span>Issues Resolved</span>
            <span>{resolutionRate}%</span>
          </div>
          <div className="w-full h-2 bg-gray-200 rounded-full">
            <div
              className="h-2 bg-green-600 rounded-full transition-all"
              style={{ width: `${resolutionRate}%` }}
            />
          </div>
        </div>

        <div className="flex justify-between items-center mt-3">
          {isVerified && (
            <span className="text-green-700 text-sm font-medium flex items-center gap-1">
              <BadgeCheck size={16} /> Verified
            </span>
          )}
          <Link
            to={profileLink}
            className="text-blue-600 hover:underline text-sm font-semibold"
          >
            View Profile →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CandidateCard;
